import React from 'react';
import { AuthenticationsLayout } from '../../../../layouts/Authentications/AuthenticationsLayout';
import { ForgotPasswordForm } from '../../../../forgot-password/ForgotPasswordForm';
import { Navigate } from 'react-router-dom';
import useAuth from '../../../../../hooks/authentication/useAuth';

export const ForgotPassword: React.FC = () => {
    const auth = useAuth();

    return (
        <>
            {auth.isLoggedIn && <Navigate to={'/'} replace />}
            {!auth.isLoggedIn && (
                <AuthenticationsLayout>
                    <ForgotPasswordForm />
                </AuthenticationsLayout>
            )}
        </>
    );
};
